import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PageDataScheduleTypes } from '../shared/interfaces/page-data.enum';
import { PublicScheduleType } from '../shared/interfaces/type.model';
import { PublicApiService } from '../shared/services/public-api.service';
import { PublicService } from '../shared/services/public.service';

@Component({
  selector: 'app-types',
  templateUrl: './types.component.html',
  styleUrls: ['./types.component.scss']
})
export class TypesComponent implements OnInit, OnDestroy {

  private subscription!: Subscription;
  
  types!: PublicScheduleType[];
  selectedType!: PublicScheduleType;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private publicApiService: PublicApiService,
    private publicService: PublicService
  ) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.getTypes();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private getTypes(): void {
    this.subscription.add(
      this.publicApiService.getTypes().subscribe((x: any) => {
        this.types = x;
      })
    );
  }

  private navigateTo(): void {
    setTimeout(() => {
      this.router.navigate(['dentists'], { relativeTo: this.activatedRoute})
    }, 200);
  }

  public getBackRouterLink(): string | undefined {
    return this.publicService.getBackRouterLinkToClinic();
  }

  public isSelected(typeId?: string): boolean {
    if (!this.selectedType) {
      return false;
    }
    return this.selectedType.id === typeId;
  }

  public typeSelectChanged(index: number): void {
    this.selectedType = this.types[index];
    this.publicService.setPublicScheduleSelectedData(
      PageDataScheduleTypes.TYPE_SCHEDULE_DATA,
      this.selectedType
    );
    this.navigateTo();
  }

  public getDescriptionByTypeName(name: string): string {
    return this.publicService.getTypeDescriptionByName(name);
  }

  public getIconByTypeName(name: string): string {
    return this.publicService.getTypeIconByName(name);
  }
}
